<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.expense_record_feature.expense_record') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'expense-record-create' })"
            >
              {{ $t('addministration.expense_record_feature.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.expense_record_feature.search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.expense_date }}</td>
          <td>
            {{
              record.expense_item
                ? record.expense_item.expense_item_name_en
                : ''
            }}
            {{
              record.expense_item
                ? record.expense_item.expense_item_name_kh !== null
                  ? ' | ' + record.expense_item.expense_item_name_kh
                  : ''
                : ''
            }}
          </td>
          <td>
            {{ record.expense_amount }}
            {{ record.currency ? record.currency.currency_code : '' }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.description) }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'expense-record-edit',
                params: { id: record.expense_id }
              }"
              v-tooltip="$t('addministration.expense_record_feature.edit')"
              class="mr-3"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a
              href="#"
              v-tooltip="$t('addministration.expense_record_feature.delete')"
              class="text-danger"
              @click.prevent="destroy(record.expense_id)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'expense-record',
  data() {
    return {
      loading: false,
      columns: [
        {
          name: this.$t('addministration.expense_record_feature.date'),
          style: 'width: 12%;'
        },
        {
          name: this.$t('addministration.expense_record_feature.item_name'),
          style: 'width: 36%;'
        },
        {
          name: this.$t('addministration.expense_record_feature.amount'),
          style: 'width: 12%;'
        },
        { name: this.$t('addministration.expense_record_feature.description') },
        {
          name: this.$t('addministration.expense_record_feature.action'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('expenseRecord', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.expenseRecord.search
      },
      set(newValue) {
        this.$store.commit('expenseRecord/SET_SEARCH', newValue)
        this.$store.commit('expenseRecord/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('expenseRecord/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(expense_id) {
      if (
        await this.$confirmModal.danger(
          this.$t(
            'addministration.expense_record_feature.are_you_sure_to_delete'
          )
        )
      ) {
        this.$store
          .dispatch('expenseRecord/destroy', expense_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'expense-record-create') {
      this.$store.commit('expenseRecord/RESET_STATE')
      this.$store.commit('expenseRecord/SET_EXPENSE_ITEMS', [])
      this.$store.commit('expenseRecord/SET_CURRENCIES', [])
    }
    next()
  }
}
</script>
